import { render, staticRenderFns } from "./tiscaliCoverage.vue?vue&type=template&id=9a089208&"
import script from "./tiscaliCoverage.vue?vue&type=script&lang=js&"
export * from "./tiscaliCoverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports